export const UNIT_GROUP_SUPPLY = 'Supply';
export const UNIT_GROUP_DISCARD = 'Discard Pile';
export const UNIT_GROUP_HAND = 'Hand';
export const UNIT_GROUP_ELIMINATED = 'Eliminated';
export const UNIT_GROUP_RESERVE = 'Reserve';
